import React, { Component } from 'react';
import './App.css';
import * as $ from 'jquery';
import Dashboard from './dashboard/Dashboard.js';
import OnboardingContainer from './onboarding/OnboardingContainer.js';
import PasswordContainer from './guest/password/PasswordContainer.js';
import StoreContainer from './guest/store/StoreContainer.js';
import SummitContainer from './guest/summit/SummitContainer.js';
import Workshops from './guest/summit/Workshops.js';
import Webinars from './guest/webinars/webinars.js';
import Reclutamiento from './guest/reclutamiento/Reclutamiento.js';
import SurveyContainer from './guest/survey/SurveyContainer.js';
import GetSurveyDataContainer from './guest/GetSurveyData/GetSurveyDataContainer.js';
import BrokerPoliticasContainer from './guest/BrokerPoliticas/BrokerPoliticasContainer.js';
import SignupContainer from './guest/signup/SignupContainer.js';
import VcontractContainer from './guest/vcontract/VcontractContainer.js';
import TermsContainer from './guest/vcontract/TermsContainer.js';
import ExternalPaymentContainer from './guest/payment/ExternalPaymentContainer.js';
import PromotionContainer from './guest/promotion/PromotionContainer.js';
import axios from 'axios';
import md5 from 'md5';
import moment from 'moment-timezone';
import { Redirect, Route, Switch } from 'react-router-dom';
import { translate } from 'react-i18next';
import ExternalProsaAmexContainer from './guest/payment/ExternalProsaAmexContainer.js';
import InvoicePaymentStatus from './dashboard/invoices/payment/ProsaPaymentStatusContainer.js';
import FeedBack from './guest/improvement/FeedBack'
import RecoveryPasswordContainer from './guest/recoveryPassword/RecoveryPasswordContainer.js';
import AgradecimientoContainer from './guest/summit/AgradecimientoContainer.js';
import SummitAsistenciaContainer from './guest/summit_asistencia/SummitAsistenciaContainer.js';
import PhoneBoothContainer  from './PhoneBooth/PhoneBoothContainer';


import NewStoreContainer from './store/StoreContainer';
export const ERRORS = {
  INPUT: 9997,
  NONE: 9998,
  TOKEN: 9990,
  UNKNOWN: 9999
};

export const LANG = {
  EN: 'en',
  ES: 'es'
}

export const SCREEN_WIDTH = {
  EXTRA_SMALL: 576,
  SMALL: 768,
  MEDIUM: 992,
  LARGE: 1200
}

export const USER_TYPE = {
  GUEST: 1,
  MEMBER: 2,
  STAFF: 3,
  ADMIN: 4
}

export const CLAUSES = {
  "1": "",
  "2": "de MEXICO",
  "3": "NORTE",
  "4": "CENTRO",
  "5": "SUR"
};

const NAVBAR_HEIGHT = 50;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class App extends Component {

  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  componentDidMount() {
    this.setLanguage();
  }

  didLogout = () => {
    localStorage.removeItem("user");
    this.setState({ user: null });
  }

  getInitState = () => {
    const user = localStorage.getItem("user");
    return {
      lang: LANG.ES,
      user: user ? JSON.parse(user) : null
    };
  }

  getNavbarHeight = () => {
    if ($(window).width() >= SCREEN_WIDTH.SMALL) {
      return NAVBAR_HEIGHT / 2 + "px";
    } else {
      return NAVBAR_HEIGHT / 2 + "px";
    }
  }

  getTokenId = () => {
    if (process.env.REACT_APP_ENVIRONMENT === 'production' || process.env.REACT_APP_ENVIRONMENT === 'staging') {
      const now = parseInt(moment().tz("America/Monterrey").format("YYYYMMDDHHmm"), 10);
      const k = 105105;
      return md5("IOS" + (now + k) + "IOSFERA");
    } else {
      return "123";
    }
  }

  getTokenSession = () => {
    const user = this.state.user;
    return user ? user.token_session : "";
  }

  handleErrorResponse = (error) => {
    const { t } = this.props;
    switch (error) {
      case ERRORS.TOKEN:
        alert(t('app.error_token'));
        this.didLogout();
        break;
      default:
      case ERRORS.UNKNOWN:
        alert(t('app.error_unknown'));
        break;
    }
  }

  handleLanguageChange = () => {
    const lang = this.state.lang === LANG.EN ?
      LANG.ES :
      LANG.EN;

    localStorage.setItem("lang", lang);
    this.setLanguage();
  }

  handleUpdateSolicitudes = () => {
    this.getUpdateSolicitudes({
      token_id: this.getTokenId(),
      token_session: this.getTokenSession()
    });
  }

  handleLogoutClick = () => {
    console.log("Variable de pruebas",process.env.REACT_APP_TEST_VAR)
    this.logout({
      token_id: this.getTokenId(),
      token_session: this.getTokenSession()
    });
  }

  handleResponse = (response, onSuccess, onError) => {
    switch (response.data.code) {
      case ERRORS.NONE:
        if (onSuccess) {
          onSuccess(response.data.data);
        }
        break;
      default:
        if (onError) {
          onError(response.data.code, response.data.error_type, response.data.conekta_msj, response.data.msg);
        }
        break;
    }
  }

  handleThrownResponse = (thrown, onThrown) => {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled:', thrown.message);
    } else {
      // alert(thrown);
      console.warn({error: thrown.response})
      if (onThrown) {
        onThrown(thrown.response);
      }
    }
  }

  logout = (params) => {

    //salir de google si es que esta logeado
    if (window.gapi.auth2 != null) {
      var auth2 = window.gapi.auth2.getAuthInstance();
      auth2.signOut().then(function () {
        console.log('User signed out.');
      });
    }


    this.post(
      "/logout",
      params,
      (response) => this.didLogout(response),
      (error) => this.handleErrorResponse(error),
      axios.CancelToken.source()
    );
  }

  getUpdateSolicitudes = (params) => {
    this.post(
      "/updatenotificaciones",
      params,
      (response) => (response),
      (error) => this.handleErrorResponse(error),
      axios.CancelToken.source()
    );
  }

  post = (url, params, onSuccess, onError, cancelToken, onThrown) => {
    axios
      .post(process.env.REACT_APP_API_HOST + url, params, { cancelToken: cancelToken.token })
      .then((response) => this.handleResponse(response, onSuccess, onError))
      .catch((thrown) => this.handleThrownResponse(thrown, onThrown));
  }

  post_summit = (url, params, onSuccess, onError, cancelToken, onThrown) => {
    axios
      .post(process.env.REACT_APP_API_HOST_SUMMIT + url, params, { cancelToken: cancelToken.token })
      .then((response) => this.handleResponse(response, onSuccess, onError))
      .catch((thrown) => this.handleThrownResponse(thrown, onThrown));
  }

  post_store = (url, params, onSuccess, onError, cancelToken, onThrown) => {
    const options = {}
    if (cancelToken) {
      options.cancelToken = cancelToken.token;
    }
    axios
      .post(process.env.REACT_APP_API + '/store' + url, params, options)
      .then((response) => this.handleResponse(response, onSuccess, onError))
      .catch((thrown) => this.handleThrownResponse(thrown, onThrown));
  }


  post_webinar = (url, params, onSuccess, onError, cancelToken, onThrown) => {
    axios
      .post(process.env.REACT_APP_API_HOST_WEBINARS + url, params, { cancelToken: cancelToken.token })
      .then((response) => this.handleResponse(response, onSuccess, onError))
      .catch((thrown) => this.handleThrownResponse(thrown, onThrown));
  }

  post_carrera = (url, params, onSuccess, onError, cancelToken, onThrown) => {
    axios
      .post(process.env.REACT_APP_API_HOST_CARRERA + url, params, { cancelToken: cancelToken.token })
      .then((response) => this.handleResponse(response, onSuccess, onError))
      .catch((thrown) => this.handleThrownResponse(thrown, onThrown));

  }

  post_portal = (url, params, onSuccess, onError, cancelToken, onThrown) => {
    axios
      .post(process.env.REACT_APP_API + url, params, { cancelToken: cancelToken.token })
      .then((response) => this.handleResponse(response, onSuccess, onError))
      .catch((thrown) => this.handleThrownResponse(thrown, onThrown));

  }

  setLanguage = () => {
    const lang = localStorage.getItem("lang");
    if (lang) {
      this.props.i18n.changeLanguage(lang);
      this.setState({ lang: lang });
    }
  }

  setUser = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    this.setState({ user: user });
  }

  renderDashboard = () => {
    return (
      <Dashboard
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        handleLogoutClick={this.handleLogoutClick}
        lang={this.state.lang}
        post={this.post}
        setUser={this.setUser}
        user={this.state.user}
        handleUpdateSolicitudes={this.handleUpdateSolicitudes}
        postStore={this.post_store} />
    );
  }

  renderOnboardingContainer = () => {
    return (
      <OnboardingContainer
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post}
        setUser={this.setUser}
        user={this.state.user} />
    );
  }

  renderPasswordContainer = () => {
    return (
      <PasswordContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        handleLogoutClick={this.handleLogoutClick}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user} />
    );
  }

  renderecoveryPasswordContainer = () => {
    return (
      <RecoveryPasswordContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        handleLogoutClick={this.handleLogoutClick}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user} />
    )
  }

  renderStoreContainer = () => {
    return (
      <StoreContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user} />
    );
  }

  renderSummit = () => {
    return (
      <SummitContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post_summit}
        user={this.state.user} />
    );
  }

  renderSummitAsistenciaContainer = () => {
    return (
      <SummitAsistenciaContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post_summit}
        user={this.state.user} />
    );
  }

  renderWorkshops = () => {
    return (
      <Workshops
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post_summit}
        user={this.state.user} />
    );
  }

  renderWebinars = () => {
    return (
      <Webinars
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post_webinar}
        user={this.state.user} />
    );
  }

  renderReclutamiento = () => {
    return (
      <Reclutamiento
        handleLanguageChange={this.handleLanguageChange}
        handleErrorResponse={this.handleErrorResponse}
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        lang={this.state.lang}
        user={this.state.user}
        post={this.post}
      />
    );
  }

  renderSurveyContainer = () => {
    return (
      <SurveyContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user} />
    );
  }

  renderGetSurveyDataContainer = () => {
    return (
      <GetSurveyDataContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user} />
    );
  }

  renderBrokerPoliticasContainer = () => {
    return (
      <BrokerPoliticasContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        getTokenSession={this.getTokenSession}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user} />
    );
  }

  renderSignupContainer = () => {
    return (
      <SignupContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post} />
    );
  }

  renderVcontractContainer = () => {
    return (
      <VcontractContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post} />
    );
  }

  renderTermsContainer = () => {
    return (
      <TermsContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post} />
    );
  }

  renderExternalInvoicesContainer = () => {
    return (
      <ExternalPaymentContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post} />
    );
  }

  renderExternalPaymentContainer = () => {
    return (
      <ExternalProsaAmexContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post} />
    );
  }

  renderInvoicePaymentStatus = () => {
    return (
      <InvoicePaymentStatus
        getTokenId={this.getTokenId}
        getTokenSession={() => { "" }}
        post={this.post} />
    );
  }

  renderPromotionContainer = () => {
    return (
      <PromotionContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post} />
    );
  }

  renderFeedback = () => {
    return (
      <FeedBack
        getTokenId={this.getTokenId}
        post={this.post_portal}
        user={this.state.user}
        handleErrorResponse={this.handleErrorResponse}
      />
    )
  }

  renderNewStoreContainer = () => {
    return (
      <NewStoreContainer
        getNavbarHeight={this.getNavbarHeight}
        getTokenId={this.getTokenId}
        handleErrorResponse={this.handleErrorResponse}
        handleLanguageChange={this.handleLanguageChange}
        lang={this.state.lang}
        post={this.post}
        user={this.state.user}
        postStore={this.post_store}
      />
    )
  }

  renderAgradecimiento = () => {
    return (
      <AgradecimientoContainer
      getNavbarHeight={this.getNavbarHeight}
      getTokenId={this.getTokenId}
      handleErrorResponse={this.handleErrorResponse}
      handleLanguageChange={this.handleLanguageChange}
      post={this.post_summit}/>
  );
  }

  renderPhoneBooth = () => {
    return (
      <PhoneBoothContainer
      getTokenId={this.getTokenId}
      getTokenSession={this.getTokenSession}
      handleErrorResponse={this.handleErrorResponse}
      handleLanguageChange={this.handleLanguageChange}
      lang={this.state.lang}
      post={this.post}
      user={this.state.user} />
  );
  }



  render() {
    const { t } = this.props;
    return (
      <div className="App">
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/marketplace" />} />
          <Route exact path="/onboarding" component={this.renderOnboardingContainer} />
          <Route exact path="/password/:token_password" component={this.renderPasswordContainer} />
          <Route exact path="/password/recovery/:uuid" component={this.renderecoveryPasswordContainer} />
          <Route exact path="/survey" component={this.renderSurveyContainer} />
          <Route path="/getSurveyData/:survey_token/:data" component={this.renderGetSurveyDataContainer} />
          <Route path="/getSurveyData/:survey_token" component={this.renderGetSurveyDataContainer} />
          <Route path="/brokerPoliticas/:broker_asesor_id" component={this.renderBrokerPoliticasContainer} />
          <Route path="/store_old" component={this.renderStoreContainer} />
          <Route path={URI_VENTA_EN_LINEA} component={this.renderNewStoreContainer} />
          <Route exact path="/summit" component={this.renderSummit} />
          <Route exact path="/summit/asistencia/:qrcode" component={this.renderSummitAsistenciaContainer} />
          <Route path="/agradecimiento" component={this.renderAgradecimiento} />
          <Route path="/workshop/:qr_code" component={this.renderWorkshops} />
          <Route path="/webinars" component={this.renderWebinars} />
          <Route path="/mejoracontinua" component={this.renderFeedback} />
          <Route path="/reclutamiento" component={this.renderReclutamiento} />
          <Route path="/signup/:token_signup" component={this.renderSignupContainer} />
          <Route path="/vcontract/:lang/:token_vcontract" component={this.renderVcontractContainer} />
          <Route path="/terms-of-service/:clause" component={this.renderTermsContainer} />
          <Route exact path="/payment/:external_token" component={this.renderExternalInvoicesContainer} />
          <Route exact path="/payment/:external_token/:invoice_id" component={this.renderExternalPaymentContainer} />
          <Route exact path="/payment/:external_token/:invoice_id/status" component={this.renderInvoicePaymentStatus} />
          <Route path="/promotion/:external_token" component={this.renderPromotionContainer} />
          <Route path="/phoneBooth" component={this.renderPhoneBooth} />
          <Route path="/" component={this.renderDashboard} />
        </Switch>
      </div>
    );
  }
}

export default translate('common')(App);



// WEBPACK FOOTER //
// ./src/App.js